/* eslint-disable jsx-a11y/mouse-events-have-key-events */

import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { withTheme } from "shared/context/Theme";
import Submenu from "./Submenu";
import styles from "./styles.css";
import themes from "./themes";

class TextItem extends Component {
  constructor(props) {
    super(props);

    this.container = React.createRef();
    this.state = {
      isSubmenuOpen: false,
      isActive: this.getIsActive(),
    };
  }

  getIsActive = () => {
    if (typeof window === "undefined") return false;

    const { url } = this.props;

    return !!window.location.href.match(url);
  };

  handleGlobalTouchStart = () => {
    document.addEventListener("touchend", this.handleGlobalTouchEnd);
    document.removeEventListener("touchstart", this.handleGlobalTouchStart);
  };

  handleGlobalTouchEnd = (event) => {
    document.removeEventListener("touchend", this.handleGlobalTouchEnd);

    if (this.container.current.contains(event.target)) {
      event.target.click();
    }

    this.closeSubmenu();
  };

  handleMouseEnter = () => {
    const submenu = this.props;

    if (submenu) this.openSubmenu();
  };

  handleMouseLeave = () => {
    const submenu = this.props;

    if (submenu) this.closeSubmenu();
  };

  handleTouchEnd = () => {
    document.addEventListener("touchstart", this.handleGlobalTouchStart);

    this.openSubmenu();
  };

  openSubmenu = () => {
    this.setState({ isSubmenuOpen: true });
  };

  closeSubmenu = () => {
    this.setState({ isSubmenuOpen: false });
  };

  toggleSubmenu = () => {
    const { isSubmenuOpen } = this.state;

    if (isSubmenuOpen) {
      this.closeSubmenu();
    } else {
      this.openSubmenu();
    }
  };

  render() {
    const {
      theme,
      title,
      url,
      children,
      submenu,
      className,
      activeClassName,
    } = this.props;

    const { isSubmenuOpen, isActive } = this.state;

    const id = `${title.toLowerCase()}-menu-desktop`;
    const label = `${title.toLowerCase()}-heading-desktop`;

    return (
      <div
        className={cn({
          [theme.styles.item]: true,
          [theme.styles.isSubmenuOpen]: isSubmenuOpen,
          [activeClassName || theme.styles.isActive]: isActive,
          [className]: true,
        })}
        id={label}
        ref={this.container}
        aria-controls={submenu ? id : null}
        data-lpa-category="Destinations Next"
        data-lpa-action="Global Navigation Click"
        data-lpa-label={title}
        onTouchEnd={this.handleTouchEnd}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {submenu ? (
          <span className={theme.styles.link}>{children || title}</span>
        ) : (
          <a href={url} className={theme.styles.link}>
            {children || title}
          </a>
        )}
        {submenu && (
          <Submenu
            {...submenu}
            id={id}
            className={theme.styles.submenu}
            aria-hidden={isSubmenuOpen ? "false" : "true"}
            aria-labelledby={label}
          />
        )}
      </div>
    );
  }
}

TextItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  url: PropTypes.string.isRequired,
  submenu: PropTypes.shape({}),
  children: PropTypes.element,
  className: PropTypes.string,
};

TextItem.defaultProps = {
  submenu: null,
  children: null,
  className: "",
};

export default withTheme(TextItem, styles, themes);
